import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Container, Card, Alert, Collapse } from 'react-bootstrap';

const AuthDebug = () => {
  const { auth, isAuthenticated, hasRole } = useAuth();
  const [open, setOpen] = useState(false);
  
  return (
    <Container className="mt-4">
      <Card>
        <Card.Header
          onClick={() => setOpen(!open)}
          style={{ cursor: 'pointer' }}
          aria-controls="auth-debug-body"
          aria-expanded={open}
        >
          Authentication Debug Information
        </Card.Header>
        <Collapse in={open}>
          <Card.Body id="auth-debug-body">
          <pre style={{ maxHeight: '400px', overflow: 'auto' }}>
            {JSON.stringify({
              isAuthenticated,
              hasAdminRole: auth?.user?.role === 'ADMIN',
              hasRoleCheck: hasRole(['ADMIN']),
              user: auth?.user,
              token: auth?.token ? 'Token exists' : 'No token',
            }, null, 2)}
          </pre>
          
          {auth?.user?.role !== 'ADMIN' && (
            <Alert variant="danger">
              Your role is {auth?.user?.role}, not ADMIN. This is why you can't access admin pages.
            </Alert>
          )}
          
          {!isAuthenticated && (
            <Alert variant="danger">
              You are not authenticated. Please log in.
            </Alert>
          )}
        </Card.Body>
        </Collapse>
      </Card>
    </Container>
  );
};

export default AuthDebug;
